import API_ENDPOINTS from '../constants/api_endpoints';
import { realBricksApi } from './api.service';

export const getPolicyTypesService = () => {
  return realBricksApi.get(`${API_ENDPOINTS.LEGAL_POLICY.GetPolicyTypes}`);
};

export const addPolicyService = (body) => {
  return realBricksApi.post(`${API_ENDPOINTS.LEGAL_POLICY.GetPolicy}`, body);
};

export const getPolicyListService = (
  page,
  limit,
  sortField,
  sortType,
  search
) => {
  let queryString = '';

  return realBricksApi.get(
    `${API_ENDPOINTS.LEGAL_POLICY.GetPolicy}?page=${page}&limit=${limit}&sortField=${sortField}&sortType=${sortType}${queryString}`,
    {
      params: {
        ...(search && { search }),
      },
    }
  );
};

export const updatePolicyService = (body) => {
  return realBricksApi.put(`${API_ENDPOINTS.LEGAL_POLICY.GetPolicy}`, body);
};

export const getPolicyByIdService = (legalId) => {
  return realBricksApi.get(
    `${API_ENDPOINTS.LEGAL_POLICY.GetPolicy}/${legalId}`
  );
};

export const deletePolicyService = (legalId) => {
  return realBricksApi.delete(
    `${API_ENDPOINTS.LEGAL_POLICY.GetPolicy}/${legalId}`
  );
};
